module.exports = __webpack_public_path__ + "img/ANNI_Design_Round_Image_Green.3e5a9ecd.png";